import { createFileRoute } from '@tanstack/react-router';

import { CarrierTransactionsTab } from '../../../components';

const Page = () => {
  const params = Route.useParams();

  return (
    <CarrierTransactionsTab
      annuityIntegrationId={params.annuityIntegrationId}
    />
  );
};

export const Route = createFileRoute(
  '/carriers/$annuityIntegrationId/transactions'
)({
  component: Page
});
